import { render, staticRenderFns } from "./first-storage-location.vue?vue&type=template&id=ffd309ac&"
import script from "./first-storage-location.vue?vue&type=script&lang=js&"
export * from "./first-storage-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports